import { createContext, useContext } from 'react';

const FlowEditorContext = createContext({});
const FlowEditorContextProvider = FlowEditorContext.Provider;
const useFlowEditorContext = () => useContext(FlowEditorContext);

export { FlowEditorContextProvider, useFlowEditorContext };
